// extracted by mini-css-extract-plugin
export default {"userDetailsWrapper":"user-details_userDetailsWrapper__UEe-w"};